<!--
	* @Description: 学生奖励 详情
	* @Author: ZSC
	* @Date: 2023-04-07 15:27:27.809
 * @LastEditors: wanglixin wang1223634360@163.com
 * @LastEditTime: 2023-05-12 16:14:21
-->
<template>
	<div>
		<el-dialog class="w800 h630" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
			<template #header>
				<div class="header-left">
					<el-icon class="header-icon"><Document /></el-icon>
					<span class="header-title">详情</span>
				</div>
				<div class="header-right">
					<el-button type="info" text @click="closeWindow('openDetail', emits, false)">
						<el-icon><Close /></el-icon>
					</el-button>
				</div>
			</template>
			<el-descriptions :column="2" border>
				<el-descriptions-item label="学生" label-align="right" align="left" width="120px" span="2">{{ruleForm.xsxm}}</el-descriptions-item>
				<el-descriptions-item label="班级" label-align="right" align="left" width="120px" span="2">{{ruleForm.bjmc}}</el-descriptions-item>
				<el-descriptions-item label="班主任" label-align="right" align="left" width="120px" span="2">{{ruleForm.bzrxm}}</el-descriptions-item>
				<el-descriptions-item label="学期" label-align="right" align="left" width="120px" span="2">{{ruleForm.xqmc}}</el-descriptions-item>
				<el-descriptions-item label="奖励名称" label-align="right" align="left" width="120px" span="2">{{ruleForm.jlmc}}</el-descriptions-item>
				<el-descriptions-item label="奖励级别" label-align="right" align="left" width="120px" span="2">{{ruleForm.jljbbt}}</el-descriptions-item>
				<el-descriptions-item label="奖励等级" label-align="right" align="left" width="120px" span="2">{{ruleForm.jldjbt}}</el-descriptions-item>
				<el-descriptions-item label="获奖类别" label-align="right" align="left" width="120px" span="2">{{ruleForm.hjlbbt}}</el-descriptions-item>
				<el-descriptions-item label="奖励金额" label-align="right" align="left" width="120px" span="2">{{ruleForm.jlje}}</el-descriptions-item>
				<el-descriptions-item label="奖励文号" label-align="right" align="left" width="120px" span="2">{{ruleForm.jlwh}}</el-descriptions-item>
				<el-descriptions-item label="颁奖单位名称" label-align="right" align="left" width="120px" span="2">{{ruleForm.bjdwmc}}</el-descriptions-item>
				<el-descriptions-item label="奖励类型" label-align="right" align="left" width="120px" span="2">{{ruleForm.jllxbt}}</el-descriptions-item>
				<el-descriptions-item label="奖励方式" label-align="right" align="left" width="120px" span="2">{{ruleForm.jlfsbt}}</el-descriptions-item>
				<!-- <el-descriptions-item label="状态：0-已录入，1-已提交，9-审批通过，10-拒绝" label-align="right" align="left" width="120px" span="2">{{ruleForm.zt}}</el-descriptions-item> -->
			</el-descriptions>
			<template #footer>
				<div class="dialog-footer">
					<div></div>
					<div class="footer_but">
						<el-button type="info" @click="closeWindow('openDetail', emits, false)">关闭</el-button>
					</div>
				</div>
			</template>
		</el-dialog>
	</div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadData, closeWindow } from '@/api/common.js'

const props = defineProps({ openDetail: { type: Boolean, required: true }, row: { type: Object, required: false } })
const ruleForm = ref({})
const emits = defineEmits(['update:openDetail'])

watch(
	() => props.openDetail,
	() => {
		if (props.openDetail) {
			loadData({
				url: '/api/v2/xuesheng/xueshengjiangli/' + props.row.id,
				ruleForm,
				loadSuccess: function (res) {

				}
			})
		}
	}, { deep: true, immediate: true })
</script>
